import { IReceipt } from '../../../common/interfaces/dtos/IReceipt';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from '../../../common/api/emerald-request';

export const transactionSave = async (transactionId: string): Promise<IReceipt[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/${transactionId}/save`,
    method: 'POST',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<IReceipt[]>(emeraldRequestParams);
};
